<div class="total-score-div" fxFlex fxLayout="column">
    <div class="total-score-display" fxLayout="row">
        <span fxFlexFill *ngIf="!isNaN(score) && score !== undefined && score !== null">{{ score }}</span>
        <span fxFlexFill *ngIf="score === undefined || score === null || isNaN(score)">&ndash;</span>
    </div>
    <div class="score-label-div">
        <span [ngClass]="category">{{ category.toUpperCase() }} &mdash;</span>
    </div>
</div>